/** Auth0 Connections **/
export const AUTH0_DB_CONNECTION = 'Username-Password-Authentication'; // DB connection for email/password login
export const AUTH0_GOOGLE_CONNECTION = 'google-oauth2'; // Google connection for social login
export const AUTH0_APPLE_CONNECTION = 'apple'; // Apple connection for social login
export const AUTH0_LOGIN_PATH = '/api/auth0/login'; // Login path for Auth0

/**
 * Landing page for the Kinde→Auth0 Apple migration. Used as the `returnTo` for
 * the migration login so `onCallback` can route the migration outcome here
 * (`?migration=success|failed`) — kept as a single source of truth shared by the
 * modal (sets `returnTo`), `onCallback` (detects the migration flow + appends the
 * result), and the page route.
 */
export const AUTH0_APPLE_MIGRATION_STATUS_PATH = '/auth0/apple-migration-status';
